import React from "react";
import { Reveal, CTAButton, Overline } from "@/components/primitives";
import LeadDialog, { DOCS } from "@/components/forms/LeadDialog";
import { EVENT } from "@/data/site";

export function CtaStrip({ title = "Be in the room when India sets its next fuel target.", subtitle, showBrochure = true }) {
  return (
    <section className="relative overflow-hidden bg-navy grain py-20 md:py-24">
      <div className="pointer-events-none absolute -right-20 top-0 h-72 w-72 rounded-full bg-lime/20 blur-[120px]" />
      <div className="relative mx-auto max-w-4xl px-6 text-center md:px-12">
        <Reveal>
          <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-white sm:text-4xl">{title}</h2>
          <p className="mt-4 text-slate-300">{subtitle || `${EVENT.dates} · ${EVENT.venue}.`}</p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <CTAButton to="/register" data-testid="cta-register">Register Now</CTAButton>
            {showBrochure && (
              <LeadDialog
                formType="brochure"
                title="Download the Brochure"
                description="Get the full programme, sponsor and exhibitor details — instant PDF download."
                ctaLabel="Get the brochure"
                successMsg="Sent. Your download is starting now."
                downloadUrl={DOCS.brochure.url}
                downloadName={DOCS.brochure.name}
                trigger={<CTAButton variant="outline" className="text-white" data-testid="cta-brochure">Download the Brochure</CTAButton>}
              />
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function SponsorProposalBand({ title = "Position your brand at the centre of India's ethanol economy." }) {
  return (
    <section className="relative overflow-hidden bg-navy grain py-16 md:py-20" data-testid="sponsor-proposal-band">
      <div className="pointer-events-none absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-lime/15 blur-[120px]" />
      <div className="relative mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-6 md:flex-row md:items-center md:px-12">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-lime">Sponsorship Proposal 2026</p>
          <h2 className="mt-3 font-display text-3xl font-semibold leading-tight tracking-tight text-white sm:text-4xl">{title}</h2>
          <p className="mt-3 text-slate-300">800+ decision-makers · 50+ exhibitors · policy-level visibility. See tiers, deliverables and stage opportunities in the official proposal.</p>
        </div>
        <div className="flex shrink-0 flex-wrap gap-4">
          <LeadDialog
            formType="sponsorship_proposal"
            title="Get the Sponsorship Proposal"
            description="Tiers, deliverables and branding opportunities — instant PDF download."
            ctaLabel="Get the proposal"
            successMsg="Sent. Your download is starting now."
            downloadUrl={DOCS.sponsorProposal.url}
            downloadName={DOCS.sponsorProposal.name}
            trigger={<CTAButton data-testid="band-proposal-cta">Download the Proposal</CTAButton>}
          />
          <CTAButton to="/contact" variant="outline" className="text-white">Talk to the team</CTAButton>
        </div>
      </div>
    </section>
  );
}

export function TagGrid({ tags, accent = "emerald" }) {
  return (
    <div className="flex flex-wrap gap-2.5">
      {tags.map((t) => (
        <span
          key={t}
          className="rounded-full border border-border bg-white px-4 py-2 text-sm font-medium text-navy/80 transition-colors hover:border-emerald2 hover:text-emeraldDeep"
        >
          {t}
        </span>
      ))}
    </div>
  );
}

export { Overline };
